import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import SectionHeader from '../components/SectionHeader';
import '../styles/WhatWeDoPage.css';
import SEO from '../components/SEO';
import { WORK_AREAS, APPROACH } from '../data/content';

const WhatWeDoPage: React.FC = () => {
  return (
    <>
      <SEO
        title="What We Do"
        description="EF21's areas of work: education in emergencies, teacher capacity development, research and evidence, community engagement and local leadership, and mental health and psychosocial support."
        keywords="education in emergencies, teacher capacity development, MEAL, research, community engagement, local leadership, MHPSS, Myanmar, humanitarian programmes"
      />
      <Hero
        title="What We Do"
        subtitle="Our areas of work respond to locally identified priorities in crisis-affected communities"
      />

      {WORK_AREAS.map(area => (
        <section id={area.id} className="work-section" key={area.id}>
          <div className="container">
            <SectionHeader title={`${area.icon} ${area.title}`} />
            <div className="work-details">
              <p>{area.description}</p>
              {area.items && area.items.length > 0 && (
                <>
                  <p><strong>Our work includes:</strong></p>
                  <ul>
                    {area.items.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        </section>
      ))}

      <section id="approach" className="approach-section">
        <div className="container">
          <SectionHeader
            title="How We Work"
            subtitle="Our approach to locally led, evidence-informed humanitarian and development programming"
          />

          <div className="approach-list">
            {APPROACH.map((item, index) => (
              <div className="approach-item" key={index}>
                <span className="approach-item-icon" aria-hidden="true">{item.icon}</span>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="work-cta">
            <Link to="/contact" className="btn">Partner With Us</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatWeDoPage;
